import React from "react";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import Header from "@shared/components/Header";
import Loader from "@shared/components/Loader";
import Footer from "@shared/components/Footer";
import Main from "@shared/components/Main";
import Description from "@shared/components/Description";
import PreviewScreenshots from "@shared/components/PreviewScreenshots";
import StoreLinks from "@shared/components/StoreLinks";
import Contacts from "@shared/components/Contacts";
import { useData } from "@shared/context/Data";
import styles from "@shared/styles/app.styles.css";
const logo = require("../../assets/logo1024.png");
const firstPreviewScreenshot = require("../../assets/1.png");
const seconfPreviewScreenshot = require("../../assets/2.png");
const thirdPreviewScreenshot = require("../../assets/3.png");
const previewScreenshots = [
    {
        src: firstPreviewScreenshot,
        alt: "Preview"
    },
    {
        src: seconfPreviewScreenshot,
        alt: "Select Screen"
    },
    {
        src: thirdPreviewScreenshot,
        alt: "Learn Screen"
    }
];
const APP_STORE_URL = "https://apps.apple.com/app/phrasal-verbs-learn-them/id1596154929";
const PLAY_MARKET_URL = "https://play.google.com/store/apps/details?id=com.app.phrasalverbs";
function HeaderWithIntl() {
    const intl = useIntl();
    return (React.createElement(Header, { link: "/phrasal-verbs/", logoSrc: logo, logoAlt: intl.formatMessage({ id: "LogoAltText" }), mainTitle: React.createElement(FormattedMessage, { id: "MainTitle" }) }));
}
function App() {
    const { messages, language, isLoading } = useData();
    return (React.createElement(IntlProvider, { locale: language, messages: messages }, isLoading
        ? React.createElement(Loader, null)
        : (React.createElement("div", { className: styles.container },
            React.createElement(HeaderWithIntl, null),
            React.createElement(Main, null,
                React.createElement(PreviewScreenshots, { items: previewScreenshots }),
                React.createElement(StoreLinks, { appStoreUrl: APP_STORE_URL, playMarketUrl: PLAY_MARKET_URL }),
                React.createElement(Description, null,
                    React.createElement("p", null,
                        React.createElement(FormattedMessage, { id: "DescriptionStartText" })),
                    React.createElement("p", null,
                        React.createElement(FormattedMessage, { id: "DescriptionEndText" }))),
                React.createElement(Contacts, null)),
            React.createElement(Footer, null)))));
}
export default App;
